import { render, staticRenderFns } from "./CardCompany.vue?vue&type=template&id=6fcd974c&scoped=true"
import script from "./CardCompany.vue?vue&type=script&lang=js"
export * from "./CardCompany.vue?vue&type=script&lang=js"
import style0 from "./CardCompany.vue?vue&type=style&index=0&id=6fcd974c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd974c",
  null
  
)

export default component.exports